import { createPerUserDb } from "@internal/rxdb-core";
import type { RxCollection, RxJsonSchema } from "rxdb";

export interface RecordDoc {
  id: string;
  type: string;
  family_id: string;
  user_id: string | null;
  created_at: string;
  updated_at: string;
  data: Record<string, unknown>;
}

const weekAllowanceSchema: RxJsonSchema<RecordDoc> = {
  version: 0,
  primaryKey: "id",
  type: "object",
  properties: {
    id: { type: "string", maxLength: 36 },
    type: { type: "string", maxLength: 32 },
    family_id: { type: "string", maxLength: 36 },
    user_id: { type: ["string", "null"] },
    created_at: { type: "string" },
    updated_at: { type: "string" },
    data: { type: "object" },
  },
  required: ["id", "type", "family_id", "created_at", "updated_at", "data"],
  indexes: ["type", "family_id", ["family_id", "type"]],
};

type AppCollections = Record<string, RxCollection> & {
  week_allowance: RxCollection<RecordDoc>;
};

const dbApi = createPerUserDb<AppCollections>({
  namePrefix: "ukepenger",
  collections: { week_allowance: { schema: weekAllowanceSchema } },
});

export const { getDb, getDbForUser } = dbApi;
